export default "__VITE_ASSET__0aa2618d__"